import { FC, useState } from "react";
import { Box, CircularProgress, IconButton } from "@material-ui/core";
import {
  ListAlt as ListAltIcon,
  PictureAsPdf as PictureAsPdfIcon,
} from "@material-ui/icons";
const DownloadButton: FC<{
  kind: "pdf" | "csv";
  handleDownload: () => Promise<void>;
}> = ({ kind, handleDownload }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  return (
    <Box
      height="59px"
      width="59px"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      {isDownloading ? (
        <CircularProgress />
      ) : (
        <IconButton
          onClick={async () => {
            setIsDownloading(true);
            await handleDownload();
            setIsDownloading(false);
          }}
        >
          {kind === "pdf" ? (
            <PictureAsPdfIcon fontSize="large" />
          ) : (
            <ListAltIcon fontSize="large" />
          )}
        </IconButton>
      )}
    </Box>
  );
};

export default DownloadButton;
